export default __webpack_public_path__ + "static/media/onboarding3.be33dbe5.webp";